<template>
  <el-dialog
    title="添加标签"
    :center="false"
    :visible.sync="dialogTableVisible"
    :close-on-click-modal="false"
    @closed="$emit('close')"
  >
    <div class="content">
      <div class="content_left">
        <div>
          <span>标签组名称：</span>
          <el-input v-model="groupName" style="margin:10px; width:250px" placeholder="请输入组名" />
        </div>
        <div>
          <span>请选择平台：</span>
          <el-select v-model="platform" style="margin:10px; width:250px" placeholder="请选择平台">
            <el-option v-for="item in platforms" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </div>

        <!--  <el-select
          v-model="parent"
          style="margin:10px; width:250px"
          placeholder="请选择父级标签"
          @change="change"
        >
          <el-option v-for="item in parentLabel" :key="item.tagType" :label="item.title" :value="item.tagType" />
        </el-select>

        <div style="display: flex;margin:10px; position: relative;">
          <el-input v-model="subLabel" style="width:250px" placeholder="请输入标签关键字查询" />

          <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="change(parent)" />

          <div v-if="toDisplay" class="box">
            <template v-if="saveData[parent]">
              <el-checkbox v-for="item in current" :key="item.id" v-model="saveData[parent][item.id]" @change="toggle($event,item)">{{ item.tagName }}</el-checkbox>
            </template>
            <i class="el-icon-close clos" @click="toDisplay = false" />
          </div>
        </div> -->

        <ul class="content_ul">
          <li v-for="item in allLabel" :key="item.tagType" class="ul_li">
            <span class="li_span">{{ item.title }}: </span>
            <div class="li_div">
              <span
                v-for="item1 in (item.select.length > 7) && !expandOrNots.includes(item.tagType) ? item.select.slice(0, 7) : item.select"
                :key="item1.id"
                :class="{active:selected1[item.tagType] && selected1[item.tagType].filter(item2 => item2.id+''===item1.id+'').length}"
                class="div_span"
                @click="toggle1(item, item1)"
              >{{ item1.tagName }}</span>
              <span
                v-if="item.select.length > 7"
                class="div_span1"
                @click="expandOrNots.includes(item.tagType) ? expandOrNots = expandOrNots.filter(ite => ite !== item.tagType) : expandOrNots.push(item.tagType)"
              >{{ expandOrNots.includes(item.tagType) ? '收起' : '展开' }}</span>
            </div>
          </li>
        </ul>
      </div>

      <!-- <div class="content_right">
        <ul class="ul">
          <li v-for="(value,name) in selected" :key="name" class="ul_li">
            <div class="li_item">
              <span class="item_title">父级：</span>
              <span class="item" :class="{ items: value.length === Object.keys(saveData[name]).length }">
                {{ parentLabel.filter((item)=>{
                  return item.tagType+'' === name+''
                })[0].title }}
                <i v-if="value.length === Object.keys(saveData[name]).length" class="el-icon-circle-close" @click="deleteAll(name)" />
              </span>
            </div>
            <div class="li_item li_items">
              <span class="item_title">子级：</span>
              <span v-for="item,index in value" :key="item.id" class="items">{{ item.tagName }}<i class="el-icon-circle-close" @click="deleteItem(name,item,index)" /></span>
            </div>
          </li>
        </ul>
      </div> -->

      <div class="content_right">
        <div style=" margin-bottom: 17px; display: flex;  justify-content: flex-end;">
          <el-button size="mini" type="primary" @click="reset">重置</el-button>
        </div>
        <ul class="ul">
          <li v-for="(value,name) in selected1" :key="name" class="ul_li">
            <div class="li_item">
              <span class="item_title">父级：</span>
              <span class="item" :class="{ items: value.length === allLabel.filter(item=>item.tagType+''===name+'')[0].select.length }">
                {{ allLabel.filter(item=>item.tagType+''===name+'')[0].title }}
                <i v-if="value.length === allLabel.filter(item=>item.tagType+''===name+'')[0].select.length" class="el-icon-circle-close" @click="deleteAll1(name)" />
              </span>
            </div>
            <div class="li_item li_items">
              <span class="item_title">子级：</span>
              <span v-for="item,index in value" :key="item.id" class="items">{{ item.tagName }}<i class="el-icon-circle-close" @click="deleteItem1(name,item.id, index)" /></span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="determine">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { searchLabel, addAdministratorLabel, getAllLabelList } from '@/api/labelGroup.js'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  mixins: [convertToHump],
  props: {
    baseTag: {
      type: Object,
      default() {
        return {}
      }
    },
    platforms: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogTableVisible: true,
      groupName: '', // 组名称
      parent: undefined, // 父标签id
      parentLabel: Object.values(this.baseTag), // 父标签数组
      subLabel: undefined, // 搜索内容
      platform: '', // 平台id
      saveData: {}, // 存储
      current: [], // 当前的子项
      selected: {}, // 选中的标签
      toDisplay: false, // 是否显示弹窗
      allLabel: [],
      selected1: {},
      expandOrNots: [] // 存储是否展开
    }
  },
  created() {
    window.pp = this
    this.getAllLabelList()
  },
  methods: {

    // 搜索
    async change(id) {
      if (this.parent === undefined) {
        this.$message({
          message: '请选择父级标签',
          type: 'warning'
        })
        return
      }
      if (this.parent !== id || !this.subLabel) {
        this.subLabel = undefined
      }

      const data = await searchLabel({
        tag_type: id,
        tag_name: this.subLabel
      })
      const arr = this.convertToHump(data.data.list)

      if (!this.saveData[id]) {
        this.saveData[id] = {}
        arr.forEach((ie) => {
          this.saveData[id][ie.id] = false
        })
      }
      this.current = arr
      this.toDisplay = true
      this.$forceUpdate()
    },

    // 选标签
    /* toggle(bool, item) {
      if (bool) {
        this.selected[this.parent] = this.selected[this.parent] ? this.selected[this.parent] : []
        this.selected[this.parent].push(item)
      } else {
        let index = null
        this.selected[this.parent].forEach((ie, index1) => {
          if (ie.id === item.id) {
            index = index1
          }
        })
        this.selected[this.parent].splice(index, 1)
        !this.selected[this.parent].length && delete this.selected[this.parent]
      }
      this.$forceUpdate()
    }, */

    toggle1(parent, children) {
      if (!this.selected1[parent.tagType]) {
        this.selected1[parent.tagType] = []
        this.selected1[parent.tagType].push(children)
      } else {
        let index = null
        const ar = this.selected1[parent.tagType].filter((item, index1) => {
          if (item.id === children.id) {
            index = index1
          }
          return item.id === children.id
        })

        if (this.selected1[parent.tagType].length && !parent.isMultiple && !this.selected1[parent.tagType].filter(item => item.id === children.id).length) {
          /* this.$message({
            message: parent.title + ': 只能单选',
            type: 'warning'
          }) */
          this.selected1[parent.tagType].splice(index, 1)
          this.selected1[parent.tagType].push(children)
        } else {
          if (ar.length) { // 进行删除操作
            this.selected1[parent.tagType].splice(index, 1)
            this.selected1[parent.tagType].length || delete this.selected1[parent.tagType]
          } else { // 进行添加操作
            this.selected1[parent.tagType].push(children)
          }
        }
      }
      this.$forceUpdate()
    },

    // 删除单项
    /* deleteItem(parentId, item, index) {
      this.selected[parentId].splice(index, 1)
      this.selected[parentId].length || delete this.selected[parentId]

      this.saveData[parentId][item.id] = false

      this.$forceUpdate()
    }, */

    // 删除一组
    /* deleteAll(parentId) {
      delete this.selected[parentId]
      for (const key in this.saveData[parentId]) {
        this.saveData[parentId][key] = false
      }
      this.$forceUpdate()
    },
 */

    deleteAll1(parentId) {
      delete this.selected1[parentId]
      this.$forceUpdate()
    },

    deleteItem1(parentId, childrenId, index) {
      this.selected1[parentId].splice(index, 1)
      this.selected1[parentId].length || delete this.selected1[parentId]
      this.$forceUpdate()
    },

    async determine() {
      // eslint-disable-next-line no-unreachable
      let arr = []
      const data = {
        tag_group_name: this.groupName,

        tag_ids: Object.values(this.selected1).map((item) => {
          return item.map((item1) => {
            return item1.id
          })
        }).forEach(item => (arr = arr.concat(item))) || arr,

        platform_id: this.platform
      }

      // eslint-disable-next-line no-unreachable
      if (this.verification(data)) {
        await addAdministratorLabel(data)
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('close', true)
      }
    },

    verification(data) {
      if (!data.tag_group_name || !data.platform_id) {
        this.$message({
          message: data.tagGroup_name ? '请选择平台' : '请填写组名',
          type: 'warning'
        })
        return false
      }
      if (!data.tag_ids.length) {
        this.$message({
          message: '请选择标签',
          type: 'warning'
        })
        return false
      }

      return true
    },

    async getAllLabelList() {
      const data = await getAllLabelList()
      this.allLabel = this.convertToHump(data.data)
    },

    // 重置
    reset() {
      this.selected1 = {}
    }
  }
}
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
  list-style-type: none;
}
.content {
  height: 467px;
  display: flex;
}
.content .content_left {
  width: 50%;
  padding: 10px;
  display: flex;
  flex-direction: column;

  .content_ul{
    margin: 0px;
    padding: 0px;
    overflow: auto;
    box-shadow: 0px 0px 2px rgb(131, 131, 131);
    padding-left: 5px;
    .ul_li{
      display: flex;
      padding: 5px 0px;
      /* align-items: center; */
      .li_span{
        display: inline-block;
        width: 122px;
        padding: 4px 0px;
        white-space: nowrap;
        min-width: 122px;
      }
      .li_div{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .div_span{
          padding: 4px 7px;
          cursor: pointer;
          margin: 2px 3px;
          white-space: nowrap;
          &:not(.active):hover{
            background-color: rgb(226, 226, 226);
          }

          &.active{
            background-color: rgb(84, 151, 206);
            color: #ffffff;
          }
        }

         .div_span1{
            font-size: 5px;
            height: 17px;
            width: 31px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgb(100, 99, 99);
            align-items: flex-end;
            border-radius: 4px;
            margin-left: 25px;
            color: #ffffff;
            cursor: pointer;
          }
      }
    }
  }
}

.content .content_right {
  width: 50%;
  padding: 10px;
  border-left: 1px solid black;
  overflow: auto;

  .ul{
    margin: 0px;
    padding: 0px;
    .ul_li{
      margin-bottom: 11px;
      &:not(:last-child){
          border-bottom: 1px solid #ccc;
      }

      .li_item{
        margin: 6px 0px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        &.li_items{
          margin: 10px 0px;
        }

        .item{
          &.items{
            i{
              font-size: 15px;
            }
          }
        }
        .items{
           padding: 5px 11px;
           border-radius: 14px;
           box-shadow: 0px 0px 3px rgb(116, 115, 115);
           display: flex;
           align-items: center;
           margin: 5px;
           i{
             margin-left: 10px;
             font-size: 18px;
             cursor: pointer;
           }
        }
      }
    }
  }
}
.box{
    position: absolute;
    width: 90%;
    height: 200px;
    border-radius: 6px;
    box-shadow: 0px 0px 3px rgb(97, 97, 97);
    background-color: #ffffff;
    top: 45px;
    z-index: 11;
    overflow: auto;
    padding: 10px;
    padding-top: 30px;
    .clos{
      position: absolute;
      top: 5px;
      right: 8px;
      font-size: 21px;
      cursor: pointer;
    }
}
@media (max-width: 768px){
  .content .content_left .content_ul .ul_li .li_div .div_span1{
    font-size: 3vw !important;
  }
  .content_left{
    padding:0px !important;
    margin-right:4vw;
  }
  .content .content_left .content_ul .ul_li .li_span,.content .content_left .content_ul .ul_li .li_div .div_span{
    font-size:2.5vw;
  }

}
</style>
